<template>
    <div class="">
		<h2 class="main-title mb-3">Forms</h2>
        <div class="card">
            <div class="card-header card1">
                        <strong>Forms</strong>
                        <router-link to="/forms/create" type="submit" class="btn d-flex align-item-center btn-primary me-2">
                            <i class="ri-add-line me-1"></i>
                            ADD FORM
                        </router-link>
            </div>
            <div class="card-body">
                <div class="form-group mb-2 d-flex">
                    <input class="form-control form-control-sm" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                </div>
                <div class="table-responsive table-responsive-sm">
                    <table class="table table-sm text-nowrap table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="text-center">#</th>
                                <th @click="sort('field_name')">
                                    Field Name
                                    <span>
                                        <i v-if="meta.keyword == 'field_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'field_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('display_name')">
                                    Display Name
                                    <span>
                                        <i v-if="meta.keyword == 'display_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'display_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('field_type')">
                                    Field Type
                                    <span>
                                        <i v-if="meta.keyword == 'field_type' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'field_type' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('field_values')">
                                    Field Values
                                    <span>
                                        <i v-if="meta.keyword == 'field_values' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'field_values' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('is_required')">
                                    Is Required
                                    <span>
                                        <i v-if="meta.keyword == 'is_required' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'is_required' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                 <th @click="sort('field_length')">
                                   Field Length
                                    <span>
                                        <i v-if="meta.keyword == 'field_length' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'field_length' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="forms.length == 0">
                                <td colspan="10" class="text-center">No records found</td>
                            </tr>
                            <tr v-for="(form, key) in forms" :key="key">
                                <td class="text-center">{{ meta.from + key }}</td>
                                <td>{{ form.field_name }}</td>
                                <td>{{ form.display_name }}</td>
                                <td>{{ form.field_type }}</td>
                                <td>{{ form.field_values }}</td>
                                <td>{{ form.is_required}}</td>
                                <td>{{ form.field_length }}</td>
                                <td class="text-center" >
                                    <div class="form-switch form-switch" >
                                        <input class="form-check-input" type="checkbox" role="switch" :id="'form' + form.form_id" :checked="form.deleted_at ? 0 : 1" :value="form.deleted_at ? 0 : 1" @change="deleteForm(form)" :disabled="form.field_name=='Email'"/>
                                        <label class="custom-control-label" :for="'form' + form.form_id"></label>
                                    </div>
                                </td>
                                <td class="text-center" >
                                    <nav v-if="form.field_name!='Email' && !form.deleted_at">
                                        <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(form)" ><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                    </nav>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                    <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                    </select>
                    <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
	import MultiSelect from 'primevue/multiselect';
    export default {
        components: { Pagination, MultiSelect },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "dynamic_form_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                forms: [],
                form: "",
				errors: [],

            };
        },
        mounted() {
			this.index();
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "dynamicForm/paginateDynamicForm", data: vm.meta })
                    .then(function (response) {
                        vm.forms = response.data.data.data;
                        vm.meta.totalRows = response.data.data.meta.total;
                        vm.meta.lastPage = response.data.data.meta.lastPage;
                        vm.meta.from = response.data.data.meta.from;
						const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            edit(form) {
                this.$router.push("/forms/" + form.dynamic_form_id + "/edit");
            },

            deleteForm(form) {
                let vm = this;
                let loader = vm.$loading.show();
                form.status = form.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "dynamicForm/deleteDynamicForm", data: form })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.error;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
			},
        },
    };
</script>
